export default __webpack_public_path__ + "static/media/wayagram.41f374a0.png";